import styled from "styled-components";

export const TableSummaryStyle = styled.div`
  table {
    tbody {
      tr {
        td {
          :first-child {
            font-weight: bold;
          }
        }
      }
    }
  }
`;

export const TableRigSummaryStyle = styled.div`
  table {
    tbody {
      tr {
        :last-child {
          td {
            border-top: 5px double black;
            font-weight: bold;
          }
        }
      }
    }
  }
`;
